import React from "react";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import Yup from "yup";
import get from "lodash/get";
import has from "lodash/has";
import { withStyles } from "@mui/styles";
import { FormControl, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SimpleSnackbar from "common/components/SimpleSnackbar";
import { FORM_SUBMISSION_ERROR } from "common/constants";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Category name is required"),
});

const CategoriesForm = ({ classes, handleSubmit, initialValues, isEdit }) => (
  <Formik
    enableReinitialize
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={handleSubmit}
  >
    {({ values, errors, handleChange, status, touched }) => (
      <Form>
        <Grid size={{ xs: 12 }}>
          <FormControl className={classes.formControl}>
            <TextField
              error={touched.name && has(errors, "name")}
              id="name"
              type="text"
              label="Category Name"
              margin="normal"
              helperText={touched.name && get(errors, "name")}
              onChange={handleChange}
              value={values.name}
            />
          </FormControl>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
          >
            {isEdit ? "Update Category" : "Create Category"}
          </Button>
          {has(errors, "http") && (
            <SimpleSnackbar message={FORM_SUBMISSION_ERROR} />
          )}
        </Grid>
        {get(status, "success") && (
          <SimpleSnackbar
            message={isEdit ? "Category updated!" : "Category Created!"}
          />
        )}
      </Form>
    )}
  </Formik>
);

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

CategoriesForm.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  isEdit: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CategoriesForm);
